import { site, template } from '@yola/ws-sdk';
import store from 'src/js/store';

const getTemplateBuildSlugTrait = () => {
  const state = store.getState();
  const properties = site.selectors.getSiteProperties(state);
  const { conceptSlug } = properties;

  return conceptSlug || template.selectors.getBuildSlug(state);
};

export default getTemplateBuildSlugTrait;
